import { Component, OnInit, forwardRef, Input, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ISelect } from '../../../../core/models/select.model';

@Component({
  selector: 'form-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements OnInit {
  @Input() data: ISelect[];
  @Input() type: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() margin: boolean = true;
  @Input() parentValue: boolean = false;
  @Input() initialValue: string;
  @Input() loading: boolean;
  @Output() parentValueChange: EventEmitter<string>;
  @Output() clickEvent: EventEmitter<Event>;

  public value: string;

  private _onChange = (_: any) => {};
  private _onTouch = () => {};

  constructor() {
    this.value = '';
    this.parentValueChange = new EventEmitter();
    this.clickEvent = new EventEmitter();
  }

  ngOnInit(): void {}

  onChange(event) {
    this.value = event.target.value;
    this.parentValueChange.emit(this.value);
    this._onTouch();
    this._onChange(this.value);
  }

  onClick(event) {
    this.clickEvent.emit(event);
  }

  writeValue(value: any): void {
    this.value = value ? value + '' : '';
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }
}
